(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('GlosaService', GlosaService);

  function GlosaService($http, ngsalConfig) {

    var service = {
      getLinhasPrincipal: getLinhasPrincipal,
      getRelatorioCorrente: getRelatorioCorrente,
      getRegistros: getRegistros,
      getFeitosMes: getFeitosMes,
      getFeitosAbertosMais30Dias: getFeitosAbertosMais30Dias,
      getEnvioRegistro: getEnvioRegistro,
      recuperaJustificativaGlosaTotalByRmenDK: recuperaJustificativaGlosaTotalByRmenDK
    };

    return service;

    function getLinhasPrincipal(pessDk,relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/"+pessDk+"/relatorio/"+relDk+"/principal").then(function (response) {
          return response.data;
        });

      return promise;
    }

    function getRelatorioCorrente(pessDk,relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDk).then(function (response) {
          return response.data;
        });

      return promise;
    }

    function getRegistros(pessDk, relDK, paiDK) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDK + "/" + paiDK)
        .then(function (response) {
          return response.data;
      });

      return promise;
    }

    function getFeitosMes(pessDk, relDk, paiDK) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDk + "/totalizador/" + paiDK)
      .then(function (response) {
          return response.data;
      });

      return promise;
    }

    function getFeitosAbertosMais30Dias(pessDk,relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDk + "/abertos30dias")
      .then(function (response) {
          return response.data;
      });

      return promise;
    }

    function getEnvioRegistro(pessDk,relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDk + "/msmMca")
      .then(function (response) {
            return response.data;
      });

      return promise;
    }

    function recuperaJustificativaGlosaTotalByRmenDK(pessDk,relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/"+ pessDk + "/relatorio/" + relDk + "/glosaTotal")
      .then(function (response) {
          return response.data;
      });

      return promise;
    }
  }

})();
